import { SET_BACK_URL, SET_PREV_ORDER_HISTORY, SET_STORE_GROUP_CODE } from '@/store/_actions/actionTypes'
import service from '@/backend/modnpay_app_api'
import Vue from 'vue'
export default Vue.extend({
  data () {
    return {
      pageNumber: 1,
      appOrder: {}
    }
  },
  props: {
    isBillHistory: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    prevOrderHistory () { return this.$store.getters.prevOrderHistory }
  },
  methods: {
    async orderListDetail (order) {
      const req = {
        pageNumber: this.pageNumber,
        storeGroupCode: order.storeGroupCode,
        orderCode: order.orderCode,
        storeCode: order.storeCode
      }
      // backUrl 설정
      this.$store.commit(SET_BACK_URL, this.$route.name)
      // 영수증 뒤로가기 할 때 호출할 api data
      this.$store.commit(SET_PREV_ORDER_HISTORY, { ...req })
      // ReceiptComponent.vue created() 에서 사용
      this.$store.commit(SET_STORE_GROUP_CODE, order.storeCode)
      const { data } = await service.orderListDetail(req)
      if (data.resultCode === 0) {
        this.appOrder = data
        // packingFlag 0: 매장, 1: 픽업, 2: 배달
        // orderProgressFlag: 1: 조리중, 2: 조리완료, 3: 픽업 완료(배달 중) 4: 주문취소, 5: 주문완료
        // 배달, 조리 상태 로컬 디버깅 코드
        // this.appOrder.orderProgressFlag = 4
        // this.appOrder.packingFlag = 2
        // this.appOrder.agenciesFlag = 1
        this.createPopUp('#orderDetailList.cusLayer')
      }
    },
    checkAndShowOrder () {
      // 영수증화면에서 뒤로가기 버튼을 눌렀을 경우
      if (this.isBillHistory) {
        this.orderListDetail(this.prevOrderHistory)
      }
    }
  }

})
